const deliveryManagement: any = {
  all: 'delivery_management',
  deleteDelievery: 'delivery_management:delete_delivery',
  settings: 'delivery_management:settings',
  bidVariables: 'delivery_management:bid_variables',
};

export default deliveryManagement;